import React, { useEffect, useState } from "react";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import PageHeader from "../../../../shared/PageHeader/PageHeader";
import {
  Autocomplete,
  Box,
  Card,
  CardContent,
  Divider,
  FormControl,
  Grid2,
  TextField,
  Typography,
  Button as MatButton,
  Menu,
  MenuItem,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableSortLabel,
  TableCell,
  TableBody,
  TablePagination,
  Tooltip,
} from "@mui/material";
import { STATUS_CUSTOM_OTHERS } from "../../../../utils/static-masters";
import ExportIcon from "../../../../assets/images/icons/export.svg";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import ViewTableWrapper from "../../../../shared/ViewTableWrapper/ViewTableWrapper";
import { useLocation, useNavigate } from "react-router-dom";
import { getUser } from "../../../../utils/types";
import API from "../../../../api/axios";
import SlotStatus from "../../../../shared/SlotStatus/SlotStatus";
import DataNotFound from "../../../../shared/DataNotFound/DataNotFound";
import DataLoader from "../../../../shared/DataLoader/DataLoader";
import moment from "moment";
import QueryManagementListing from "../../QueryManagement/QueryManagementListing/QueryManagementListing";
import { QUERY_STATUS} from "../../../../utils/static-masters";
import { handleDate } from "../../../../shared/CommonFunctions/CommonFunction";

const QueryTrackerListing = () => {
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [queries, setQueries] = useState([]);
  const userData = getUser();
  const navigate = useNavigate();
  const location = useLocation();
  const roleCode = userData?.roles?.role_code;
  const [sortBy, setSortBy] = useState("title");
  const [sortOrder, setSortOrder] = useState<any>("asc");

  const persistedQueryStatus = location?.state?.queryStatusState ?? undefined;
  const persistedPagination = location?.state?.paginationState ?? {};

  const [selectedQueryStatus, setSelectedQueryStatus] = useState<any>(persistedQueryStatus);
  const [page, setPage] = useState(persistedPagination.page ?? 0);
  const [rowsPerPage, setRowsPerPage] = useState(persistedPagination.rowsPerPage ?? 5);
  const [offset, setOffset] = useState<number>(persistedPagination.offset ?? 0);

  let data = {
    queryResponse: true,
    offset: offset,
    limit: rowsPerPage,
    sort: sortBy,
    status:selectedQueryStatus?.id || ""
  };

  const handleSort = (property: any) => {
    const isAsc = sortOrder === "asc";
    setSortOrder(isAsc ? "desc" : "asc");
    setSortBy(sortOrder === "asc" ? `-${property}` : property);
  };

  const handleQueryStatusFilterChange = (event: any, newValue: any) => {
    setSelectedQueryStatus(newValue);
  };

  //api call function for candidate user
  const getQuery = async () => {
    setLoading(true);
    const url: string =
      roleCode === "candidate"
        ? "/query/candidate/my/queries"
        : "/query/get/all";
    try {
      const response = await API.post(url, {
        ...data,
      });
      setQueries(response?.data?.data);
      setTotalRecords(response?.data?.meta?.filter_count);
    } catch (error) {
      // Failed to fetch candidate data
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  if(roleCode === "candidate"){
    getQuery();
  }
  }, [roleCode, offset, rowsPerPage, sortOrder, sortBy, selectedQueryStatus]);

  const handlePageChange = (event: any, newPage: any) => {
    setPage(newPage);
    setOffset(newPage * rowsPerPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      {roleCode === "candidate" ? (
        <PageWrapper>
          <PageHeader title="Query Tracker"></PageHeader>
          <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
            <CardContent sx={{ padding: { xs: 0, md: "16px" } }}>
              <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                  <Typography variant="body1">Candidate Name</Typography>
                  <Typography variant="subtitle2">
                    {userData?.user?.fullname}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                  <Typography variant="body1">Mobile Number</Typography>
                  <Typography variant="subtitle2">
                    {userData?.user?.mobile}
                  </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                  <Typography variant="body1">Email Address</Typography>
                  <Typography variant="subtitle2">
                    {userData?.user?.email}
                  </Typography>
                </Grid2>
                <Grid2 size={{xs: 12, sm: 6, md: 4, lg: 3}} marginBottom={4}>
              <Typography variant="body1">INFRACON Status</Typography>
              <Typography variant="subtitle2">{userData?.user?.is_infracon_verified?"Verified":'Not Verified'}</Typography>
            </Grid2>
              </Grid2>

              <Box marginTop={2}>
                <ViewTableWrapper>
                  <ViewTableWrapper.Header title="Total Queries">
                    <Box display="flex" sx={{justifyContent:{sx:"start",sm:"end"}}}  gap={2}>
                  {/* <FormControl
                    sx={{ width: "150px" }}
                    size="small"
                    className="status-dropdown"
                  > */}
                   <Autocomplete
                          size="small"
                          disablePortal
                          options={QUERY_STATUS || []}
                          getOptionLabel={(option: any) => option?.title || ""}
                          value={selectedQueryStatus} // Set selected status
                          onChange={(event, newValue) => {
                            handleQueryStatusFilterChange(event, newValue);
                            setOffset(0);
                            setPage(0);
                          }}
                          sx={{
                            width: { xs: "50%", sm: "150px", md: "150px" },
                            "& .MuiAutocomplete-inputRoot": {
                              backgroundColor: "white",
                              borderRadius: "10px",
                            },
                            "&:hover:": {
                              border: "transparent",
                            },
                            "& .MuiAutocomplete-clearIndicator, & .MuiAutocomplete-popupIndicator": {
                              "&:hover": {
                                backgroundColor: "transparent", // Remove hover effect
                              },
                            },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Query Status"
                              variant="outlined"
                              placeholder="Query Status"
                              InputProps={{
                                ...params.InputProps,
                                // disableUnderline: true,
                                sx: {
                                  backgroundColor: "white",
                                  padding: "6px 12px",
                                  "&:hover": {
                                    borderColor: "#fff",
                                  },
                                },
                              }}
                            />
                          )}
                        />
                  {/* </FormControl> */}
                  {/* <MatButton
                    variant="outlined"
                    color="inherit"
                    startIcon={<img src={ExportIcon} alt="export" />}
                    endIcon={
                      <KeyboardArrowDownRoundedIcon
                        style={{ color: "#8F8F8F" }}
                      />
                    }
                    onClick={handleMenuOpen(setExportAnchorEl)}
                    sx={{
                      backgroundColor: "#fff",
                      border: "1px solid #E6E7E9",
                    }}
                  >
                    Export As
                  </MatButton>
                  <Menu
                    sx={{
                      maxWidth: "100% !important",
                    }}
                    anchorEl={exportAnchorEl}
                    open={Boolean(exportAnchorEl)}
                    onClose={handleMenuClose(setExportAnchorEl)}
                  >
                    <MenuItem onClick={handleMenuClose(setExportAnchorEl)}>
                      PDF
                    </MenuItem>
                    <MenuItem onClick={handleMenuClose(setExportAnchorEl)}>
                      Excel
                    </MenuItem>
                  </Menu>  */}
                </Box>
                  </ViewTableWrapper.Header>
                  <Divider />
                  <ViewTableWrapper.Content>
                    <Box
                      marginTop={1}
                      sx={{
                        overflowY: "auto",
                        flex: "1 1 auto",
                        display: "grid",
                      }}
                    >
                      <TableContainer
                        className="secondary__table"
                        sx={{
                          maxHeight: 360,
                        }}
                      >
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell>
                                <TableSortLabel
                                  active={sortBy === "title"}
                                  direction={sortOrder}
                                  onClick={() => handleSort("title")}
                                >
                                  Query Title
                                </TableSortLabel>
                              </TableCell>
                              <TableCell>Position</TableCell>
                              <TableCell>
                                <TableSortLabel
                                  active={sortBy === "date_created"}
                                  direction={sortOrder}
                                  onClick={() => handleSort("date_created")}
                                >
                                  Created Date
                                </TableSortLabel>
                              </TableCell>
                              <TableCell align="center">Query Status</TableCell>
                              <TableCell align="center">Actions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {loading ? (
                              <TableRow>
                                <TableCell colSpan={6} align="center">
                                  <Box sx={{ height: "450px" }}>
                                    <DataLoader />{" "}
                                  </Box>
                                </TableCell>
                              </TableRow>
                            ) : queries?.length > 0 ? (
                              queries?.map((query: any) => (
                                <TableRow key={query?.id}>
                                  <TableCell>{query?.title}</TableCell>
                                  <TableCell>
                                    {query?.position_id?.name}
                                  </TableCell>
                                  <TableCell>
                                    {handleDate(query?.date_created)}
                                  </TableCell>
                                  <TableCell align="center">
                                    {query?.query_status === "open" ? (
                                      <SlotStatus type="open" />
                                    ) : query?.query_status === "closed" ? (
                                      <SlotStatus type="closed" />
                                    ) : (
                                      query?.query_status || "NA"
                                    )}
                                  </TableCell>
                                  <TableCell align="center">
                                    <Tooltip title="View User" arrow>
                                      <MatButton
                                        variant="text"
                                        onClick={() =>
                                          navigate(
                                            "/admin/query-tracker/view",
                                            {
                                              state: {
                                                data: query,
                                                queryStatusState: selectedQueryStatus,
                                                paginationState: { page, rowsPerPage, offset },
                                              },
                                            }
                                          )
                                        }
                                      >
                                        View
                                      </MatButton>
                                    </Tooltip>
                                    {query?.query_status !== "closed" && (
                                      <>
                                        <Typography
                                          sx={{
                                            display: "inline",
                                            color: "#034ea2",
                                            fontSize: "12px",
                                          }}
                                        >
                                          /
                                        </Typography>
                                        <Tooltip title="Respond" arrow>
                                          <MatButton
                                            onClick={() =>
                                              navigate(
                                                `/admin/query-tracker/respond/${query?.id}`,
                                                {
                                                  state: {
                                                    data: query,
                                                    queryStatusState: selectedQueryStatus,
                                                    paginationState: { page, rowsPerPage, offset },
                                                  },
                                                }
                                              )
                                            }
                                            variant="text"
                                          >
                                            Respond
                                          </MatButton>
                                        </Tooltip>
                                      </>
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={6} align="center">
                                  <Box
                                    sx={{
                                      height: "450px",
                                    }}
                                  >
                                    <DataNotFound />
                                  </Box>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </ViewTableWrapper.Content>
                </ViewTableWrapper>
                {queries?.length > 0 && (
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    component="div"
                    count={totalRecords}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                )}
              </Box>
            </CardContent>
          </Card>
        </PageWrapper>
      ) : (
        <QueryManagementListing></QueryManagementListing>
      )}
    </>
  );
};

export default QueryTrackerListing;
